import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { formatRwf } from '../../../utils/currency';
const lines = [{
  name: 'Rice 5kg',
  qty: 1,
  price: 7500
}, {
  name: 'Cooking oil 1L',
  qty: 2,
  price: 2900
}, {
  name: 'Sugar 1kg',
  qty: 1,
  price: 1800
}, {
  name: 'Milk 500ml',
  qty: 3,
  price: 700
}];

// Deterministic pattern standing in for the EBM verification code.
const code = [1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 1, 1];
export function ReceiptPhone() {
  const total = lines.reduce((s, l) => s + l.qty * l.price, 0);
  return <div className="w-[190px] rounded-[30px] bg-[#1A1A1A] p-[7px] shadow-[0_30px_60px_-24px_rgba(11,11,11,0.55)]" data-id="element-1333" data-mp="4esv3x29qq44">
      <div className="overflow-hidden rounded-[24px] bg-white px-3.5 pb-4 pt-6 text-ink" data-id="element-1334" data-mp="2688naye08d17">
        <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-canvas-line" data-id="element-1335" data-mp="26a390ex3o96c" />
        <div className="flex items-center justify-center gap-1 text-[9px] font-semibold text-[#1B7A3D]" data-id="element-1336" data-mp="21b036s9apyxb">
          <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-1337" data-mp="21cyauc5dl3f2" />
          Paid · Mobile money
        </div>
        <p className="mt-2 text-center text-[11px] font-semibold" data-id="element-1338" data-mp="25acihzder34y">Inzozi Mini Market</p>
        <p className="text-center text-[8px] text-ink-muted" data-id="element-1339" data-mp="2aagxfkyo3pt2">KN 5 Rd, Remera · TIN 108 452 671</p>

        <ul className="mt-3 space-y-1 border-t border-dashed border-canvas-line pt-2" data-id="element-1340" data-mp="2f3tftdcr70dd">
          {lines.map(l => <li key={l.name} className="flex justify-between text-[8px]" data-id="element-1341" data-mp="2p0o9niy30clb">
              <span className="text-ink-soft" data-id="element-1342" data-mp="2oyv3e4rdrudu">
                {l.qty} × {l.name}
              </span>
              <span className="font-medium" data-id="element-1343" data-mp="2t06u6dlzqlnm">{formatRwf(l.qty * l.price)}</span>
            </li>)}
        </ul>
        <div className="mt-2 flex justify-between border-t border-dashed border-canvas-line pt-2 text-[10px] font-semibold" data-id="element-1344" data-mp="yo9y27clsrm8">
          <span data-id="element-1345" data-mp="13mtlydarcdh8">Total</span>
          <span data-id="element-1346" data-mp="13o4pqd47dl8c">{formatRwf(total)}</span>
        </div>
        <p className="mt-1 text-[7.5px] text-ink-muted" data-id="element-1347" data-mp="26xzc29w97uqt">VAT (B-18%) incl. {formatRwf(Math.round(total * 18 / 118))}</p>

        <div className="mt-3 flex items-center gap-2 rounded-[8px] bg-canvas-warm p-2" data-id="element-1348" data-mp="21zxuxuie25hz">
          <div className="grid h-9 w-9 shrink-0 grid-cols-7 gap-[1px]" data-id="element-1349" data-mp="2fzgq7mq3pmcv">
            {code.map((on, i) => <span key={i} className={on ? 'bg-ink' : 'bg-transparent'} data-id="element-1350" data-mp="2azkueark518e" data-mpi={i} />)}
          </div>
          <div className="min-w-0 text-[7px] leading-tight text-ink-muted" data-id="element-1351" data-mp="2pw38c3r1lzb7">
            <p className="font-semibold text-ink" data-id="element-1352" data-mp="2kya6to0opth9">EBM receipt</p>
            <p data-id="element-1353" data-mp="2kvxmx5bd991k">No. 00482/NS</p>
            <p data-id="element-1354" data-mp="2yp6tky7xjgge">12 Sep 2026 · 10:42</p>
          </div>
        </div>
      </div>
    </div>;
}